// this file is updated via the package prepare script
export const version = '7.0.3';
